import { useMemo } from "react";
import { categories } from "@/mocks/categories";
import { products } from "@/mocks/products";
import { panelModes } from "@/mocks/panelContent";
import { FieldRow, LockedButton, PanelBadge, PanelCard, ReadOnlyNotice } from "../components/PanelUI";

export default function CategoriesSection() {
  const counts = useMemo(() => {
    const map: Record<string, number> = {};
    categories.forEach((category) => {
      map[category.id] =
        category.id === "novidades"
          ? products.filter((product) => product.isNew).length
          : products.filter((product) => product.categoryId === category.id).length;
    });
    return map;
  }, []);

  return (
    <div className="flex flex-col gap-6">
      <ReadOnlyNotice text={panelModes.viewNotice} />

      <PanelCard
        title="Categorias"
        description="Cada categoria mantém as cinco opções principais do catálogo aprovado, sem misturar imagens ou descrições de outras peças."
        action={<PanelBadge tone="primary">{categories.length} categorias</PanelBadge>}
      >
        <div className="flex flex-col gap-5">
          {categories.map((category) => {
            const slug = category.id === "novidades" ? "novidades" : category.id;
            const page = category.id === "novidades" ? "/novidades" : `/categoria/${category.id}`;
            return (
              <article key={category.id} className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-heading text-xl text-foreground-900">{category.name}</h3>
                    <PanelBadge tone="secondary">/{slug}</PanelBadge>
                    <PanelBadge tone="primary">{counts[category.id]} produtos</PanelBadge>
                    <PanelBadge tone="neutral">Ativa</PanelBadge>
                  </div>
                  <LockedButton icon="ri-edit-2-line" hint="Editar apenas pela administração Vellora">
                    Editar categoria
                  </LockedButton>
                </div>

                <div className="mt-3 grid grid-cols-3 gap-3 sm:max-w-md">
                  {[
                    { label: "Card · 700 × 900", url: category.image },
                    { label: "Hero desktop · 1920 × 760", url: category.heroDesktop },
                    { label: "Hero mobile · 900 × 1200", url: category.heroMobile },
                  ].map((image) => (
                    <div key={image.label}>
                      <div className="h-[150px] w-full overflow-hidden rounded-md border border-background-200 bg-background-100">
                        <img
                          src={image.url}
                          alt={`${category.name} — ${image.label}`}
                          title={`${category.name} — Amora Belle`}
                          className="h-full w-full object-cover object-top"
                        />
                      </div>
                      <p className="mt-1 text-[10px] leading-snug text-foreground-500">{image.label}</p>
                    </div>
                  ))}
                </div>

                <div className="mt-4 grid grid-cols-1 gap-x-8 lg:grid-cols-2">
                  <div className="rounded-md border border-background-200 bg-background-100 px-3 py-1">
                    <FieldRow label="Descrição" value={category.description} />
                    <FieldRow label="Texto alternativo" value={`Banner da categoria ${category.name} — Amora Belle`} />
                    <FieldRow label="Ponto focal" value={`Desktop: ${category.heroFocalDesktop} · Mobile: ${category.heroFocalMobile}`} />
                    <FieldRow label="Escurecimento do banner" value={String(category.heroOverlay)} />
                  </div>
                  <div className="rounded-md border border-background-200 bg-background-100 px-3 py-1">
                    <FieldRow label="Página" value={page} />
                    <FieldRow label="Tom do texto" value={category.heroTextTone === "light" ? "Claro" : "Escuro"} />
                    <FieldRow label="Ordem dos produtos" value="Mais recentes → menor preço → mais vendidos" />
                    <FieldRow label="SEO da categoria" value={`${category.name} — Amora Belle`} />
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </PanelCard>
    </div>
  );
}